import axios from 'axios';
import {
  AccommodationFilteredHistoryLogsRequest,
  AccommodationUpdateImages,
  AccommodationUploadImages,
  CopyAccommodationCommand,
  RewriteDescriptionCommand,
  SetCapacitiesCommand,
  TranslatePropertiesCommand,
} from '../../features/accommodations/accommodationsSlice';
import { AccommodationQueryFilters } from '../../features/accommodations/accommodationsSearchSlice';
import apiRequestHeaders from '../apiRequestHeaders';

export function fetchAccommodationAutoCompleteOptions(searchTerm: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { searchTerm },
  };

  return axios
    .get(
      '/accommodation/accommodations/GetAccommodationAutoCompleteOptions',
      config,
    )
    .then(res => {
      return res;
    });
}

export function fetchAllAccommodations(
  filterRequest: AccommodationQueryFilters,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    contentType: 'application/json;charset=UTF-8',
  };

  let updatedFilterRequest = { ...filterRequest };

  if (filterRequest.filterCriteria.searchString) {
    updatedFilterRequest = {
      ...filterRequest,
      filterCriteria: {
        ...filterRequest.filterCriteria,
        searchString: filterRequest.filterCriteria.searchString.trim(),
      },
    };
  }

  return axios
    .post(
      '/accommodation/accommodations/getAllAccommodations',
      updatedFilterRequest,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function fetchAllAccommodationsOffered() {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    contentType: 'application/json;charset=UTF-8',
  };

  return axios
    .get('/accommodation/accommodations/getallofferedaccommodations', config)
    .then(res => {
      return res.data;
    });
}

export function fetchAccommodationDetails(accommodationId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId },
  };

  return axios
    .get('/accommodation/accommodations/getAccommodationDetails', config)
    .then(res => {
      return res.data;
    });
}

export function fetchAccommodationAccounts(accommodationId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId },
  };

  return axios
    .get('/accommodation/accommodations/getAccommodationAccounts', config)
    .then(res => {
      return res.data;
    });
}

export function fetchAccommodationAddOnsAccounts(accommodationId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId },
  };

  return axios
    .get('/accommodation/accommodations/GetAccommodationAddOnsAccounts', config)
    .then(res => {
      return res.data;
    });
}

export function fetchAccommodationAddOns(accommodationId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId },
  };

  return axios
    .get('/accommodation/accommodations/getAccommodationAddOns', config)
    .then(res => {
      return res.data;
    });
}

export function fetchAccommodationAttributes(accommodationId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId },
  };

  return axios
    .get('/accommodation/accommodations/getAccommodationAttributes', config)
    .then(res => {
      return res.data;
    });
}

export function fetchAccommodationOwnerValidations(accommodationId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId },
  };

  return axios
    .get(
      '/accommodation/accommodations/getAccommodationOwnerValidations',
      config,
    )
    .then(res => {
      return res.data;
    });
}
// export function updateOwnerBookingsToNewOwner(accommodationId: string) {
//   const config = {
//     headers: {
//       ...apiRequestHeaders.csrfHeader(),
//       ...apiRequestHeaders.activeSiteHeader(),
//     },
//   };
//
//   return axios
//     .post(
//       '/accommodation/accommodations/updateOwnerBookingsToNewOwner',
//       accommodationId,
//       config,
//     )
//     .then(res => {
//       return res.data;
//     });
// }

export function fetchAccommodationNotes(accommodationId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId },
  };

  return axios
    .get('/accommodation/accommodations/getAccommodationNotes', config)
    .then(res => {
      return res.data;
    });
}
export function fetchAccommodationDetailsBasic(accommodationId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId },
  };

  return axios
    .get('/accommodation/accommodations/getAccommodationDetailsBasic', config)
    .then(res => {
      return res.data;
    });
}
export function fetchAccommodationImages(accommodationId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId },
  };

  return axios
    .get('/accommodation/accommodations/getaccommodationimages', config)
    .then(res => {
      return res;
    });
}

export function addAccommodation(accommodationData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accommodation/accommodations/addaccommodation',
      accommodationData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function updateAccommodation(accommodationData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post(
      '/accommodation/accommodations/updateaccommodation',
      accommodationData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function updateAccommodationAccounts(accommodationData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post(
      '/accommodation/accommodations/updateaccommodationaccounts',
      accommodationData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function updateAccommodationsAttributes(accommodationData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post(
      '/accommodation/accommodations/updateaccommodationattributes',
      accommodationData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function updateAccommodationsAddOns(accommodationData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post(
      '/accommodation/accommodations/updateaccommodationaddons',
      accommodationData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function updateAccommodationNotes(accommodationData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post(
      '/accommodation/accommodations/updateaccommodationnotes',
      accommodationData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function copyAccommodation(copyCommand: CopyAccommodationCommand) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/accommodation/accommodations/copyaccommodation',
      copyCommand,
      config,
    )
    .then(res => {
      return res.data;
    });
}
export function updateAccommodationBasic(accommodationData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post(
      '/accommodation/accommodations/updateaccommodationbasic',
      accommodationData,
      config,
    )
    .then(res => {
      return res.data;
    });
}
export const uploadFilesToAzure = async (
  updateCommand: AccommodationUploadImages,
): Promise<void> => {
  const formData = new FormData();
  formData.append('accommodationId', updateCommand.accommodationId.toString());
  updateCommand.imagesWithFullPath.forEach(file => {
    formData.append('imagesWithFullPath', file);
  });
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  try {
    await axios
      .post('/azurecdn/azureblob/uploadfilestoazure', formData, config)
      .then(res => {
        return res.data;
      });
  } catch (error) {
    throw new Error('Failed to upload files to Azure Blob Storage');
  }
};

export function updateAccommodationImageIndexes(
  accommodationImagesData: AccommodationUpdateImages,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post(
      '/accommodation/accommodations/updateaccommodationimageindexes',
      accommodationImagesData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function deleteAccommodation(accommodationId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId },
  };

  return axios
    .delete('/accommodation/accommodations/deleteaccommodation/', config)
    .then(res => res.data);
}

export function deleteAccommodationImage(
  imageId: string,
  accommodationId: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { imageId, accommodationId },
  };

  return axios
    .delete('/accommodation/accommodations/deleteimagefromcdn', config)
    .then(res => res.data);
}

export function trafsferImagesGrediToCdnAccommodation(accommodationId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId },
    timeout: 600000,
  };

  return axios
    .get('/accommodation/accommodations/transferimagesfromgredi/', config)
    .then(res => res.data);
}

export function fixAccommodationImageIndexes(accommodationId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId },
  };

  return axios
    .post(
      '/accommodation/accommodations/fixaccommodationimageindexes/',
      null,
      config,
    )
    .then(res => res.data);
}
export function fetchAccommodationLogs(
  filterRequest: AccommodationFilteredHistoryLogsRequest,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/history/historylogs/getfilteredhistoryLogs', filterRequest, config)
    .then(res => {
      return res.data;
    });
}

export function rewriteDescription(data: RewriteDescriptionCommand) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post('/accommodation/accommodations/rewriteDescription/', data, config)
    .then(res => res.data);
}

export function translateDescription(data: TranslatePropertiesCommand) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/accommodation/accommodations/translateProperties', data, config)
    .then(res => res.data);
}

export function setAccommodationCapacities(command: SetCapacitiesCommand) {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  // Ensure capacityIds is properly formatted as an array of strings
  const formattedCommand = {
    ...command,
    capacitiesIdDataDto: {
      ...command.capacitiesIdDataDto,
      capacityIds: Array.isArray(command.capacitiesIdDataDto.capacityIds)
        ? command.capacitiesIdDataDto.capacityIds.flatMap(id =>
            typeof id === 'string' && id.includes(',')
              ? id.split(',').map(s => s.trim())
              : id,
          )
        : command.capacitiesIdDataDto.capacityIds,
    },
  };

  return axios
    .post(
      '/accommodation/accommodations/setcapacities',
      formattedCommand,
      config,
    )
    .then(res => res.data);
}

export function getAccommodationCapacities(accommodationId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId },
  };

  return axios
    .get('/accommodation/accommodations/getcapacities', config)
    .then(res => res.data);
}
